import { api } from "../../App";
import { getObjectFromArray } from "../../utils/smallHelpers";
import { SET_SETTINGS_LOADING, SET_SETTINGS_RESULTS_DATA } from "../types";



export const getResultsData = () => async (dispatch, getState) => {
    try {
      dispatch({ type: SET_SETTINGS_LOADING, payload: true });
      const { data } = await api.get('/results')
      const payload = getObjectFromArray(data.options)
      dispatch({ type: SET_SETTINGS_RESULTS_DATA, payload })

    } catch (ERR) {
      console.log(ERR)
    } finally {
      dispatch({ type: SET_SETTINGS_LOADING, payload: false });
    }
};